"use strict";

var __assign = function () {
  return (__assign = Object.assign || function (o) {
    for (var t, r = 1, n = arguments.length; r < n; r++) for (var i in t = arguments[r]) Object.prototype.hasOwnProperty.call(t, i) && (o[i] = t[i]);

    return o;
  }).apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.mapPositionCoords = exports.mapPartialCoords = void 0, exports.mapPartialCoords = function (o) {
  return o.map(function (o) {
    return {
      width: o.width,
      position: 0
    };
  });
}, exports.mapPositionCoords = function (o, t) {
  return void 0 === t && (t = 0), o.map(function (o) {
    return o.position > t ? __assign(__assign({}, o), {
      position: t
    }) : o;
  });
};